module.exports = __webpack_public_path__ + "img/undertakingCases20.62019f31.jpg";